import { PanelbarStructure } from "../isPanelbarDetails";
import { Helper } from "../../util/helper";
import React from "react";

export default class DeliverableTypeDetails extends React.Component<any, any> {

    render() {
        return (
            <PanelbarStructure label={""} keyPropValue={""} iconName={""} url={null}>
                Type: {this.props.value}
            </PanelbarStructure>
        );
    }
}